import application from 'application';
import internalEventCodes from 'event-system/codes/internal';

const FEATURE_PATTERNS = [
  { pattern: /^\/analytics(?:\/([^/]+))?/, feature: 'Analytics', idKey: 'reportId' },
  { pattern: /^\/tasks(?:\/([^/]+))?/, feature: 'Tasks', idKey: 'taskId' },
  { pattern: /^\/pages(?:\/([^/]+))?/, feature: 'Pages', idKey: 'pageId' },
  { pattern: /^\/databases(?:\/([^/]+))?/, feature: 'Databases', idKey: 'dataCollectionId' },
  { pattern: /^\/products(?:\/([^/]+))?/, feature: 'Products', idKey: 'productId' },
  { pattern: /^\/finance(?:\/([^/]+))?/, feature: 'Finance', idKey: 'activityId' },
  { pattern: /^\/contacts(?:\/([^/]+))?/, feature: 'Contacts', idKey: 'userId' },
  { pattern: /^\/inbox\/conversations\/([^/]+)/, feature: 'Inbox', idKey: 'conversationId' },
  { pattern: /^\/inbox/, feature: 'Inbox', idKey: null },
  { pattern: /^\/community(?:\/([^/]+))?/, feature: 'Community', idKey: 'postId' },
  { pattern: /^\/campaigns(?:\/([^/]+))?/, feature: 'Campaigns', idKey: 'campaignId' }
];
const INTERCEPT_PATHS = [
  '/analytics',
  '/tasks',
  '/pages',
  '/databases',
  '/products',
  '/finance',
  '/contacts',
  '/inbox',
  '/community',
  '/campaigns',
  '/skills'
];

export function shouldInterceptLink(link) {
  const url = new URL(link.href, window.location.origin);

  if (url.host !== window.location.host) {
    return false;
  }

  return INTERCEPT_PATHS.some((basePath) => {
    return url.pathname === basePath || url.pathname.startsWith(basePath + '/');
  });
}
export function customLinkHandler(link) {
  const url = new URL(link.href, window.location.origin);
  const to = url.pathname + url.search + url.hash;

  application.eventSystem.internal.emit(internalEventCodes.NAVIGATE_TO, {
    to: to
  });

}

function buildMessageContext() {

  const pathname = window.location.pathname;
  const context = {
    url: pathname,
    browser: {
      userAgent: navigator.userAgent,
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight
    },
    feature: null,
    currentItem: null
  };

  for (let i = 0; i < FEATURE_PATTERNS.length; i++) {
    const entry = FEATURE_PATTERNS[i];
    const match = pathname.match(entry.pattern);

    if (match === null) {
      continue;
    }

    context.feature = entry.feature;

    if (entry.idKey !== null && match[1] !== undefined) {
      context.currentItem = {};
      context.currentItem[entry.idKey] = match[1];
    }

    break;
  }

  return context;

}

export function canAcceptFeedbackForMessage(message) {

  const assistantRequest = message.metadata.assistantRequest;

  if (!assistantRequest) {
    return false;
  }

  const expiryDate = new Date(assistantRequest.createdAt);

  expiryDate.setDate(expiryDate.getDate() + assistantRequest.expiresInDays);

  if (Date.now() > expiryDate.getTime()) {
    return false;
  }

  return true;

}

export { buildMessageContext };
